// EdgeContextMenu.js - Context menu for edge operations

import React, { useEffect } from 'react';
import styled from 'styled-components';
import THEME from '../../styles/theme';

const EdgeContextMenu = ({ position, onClose, onDelete, onInsert }) => {
  // Handle escape key to close
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleInsert = () => {
    onInsert();
    onClose();
  };

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <>
      <Backdrop onClick={onClose} />
      <Menu style={{ top: position.y, left: position.x }}>
        <MenuItem onClick={handleInsert}>
          <Icon>➕</Icon>
          <MenuText>Insert Component</MenuText>
        </MenuItem>
        <MenuItem onClick={handleDelete} danger>
          <Icon>🗑️</Icon>
          <MenuText>Delete Connection</MenuText>
          <Shortcut>Del</Shortcut>
        </MenuItem>
      </Menu>
    </>
  );
};

// Styled Components
const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${THEME.zIndex.modal - 1};
`;

const Menu = styled.div`
  position: fixed;
  min-width: 200px;
  background: ${THEME.sidebarBackground};
  border: 1px solid ${THEME.borderColor};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: ${THEME.zIndex.modal};
  padding: 4px;
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s ease;
  color: ${props => props.danger ? THEME.dangerColor : THEME.textColor};

  &:hover {
    background: ${props => props.danger
      ? 'rgba(220, 20, 60, 0.15)'
      : THEME.hoverBackground};
  }
`;

const Icon = styled.span`
  font-size: 16px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MenuText = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
`;

const Shortcut = styled.span`
  font-size: 12px;
  color: ${THEME.textSecondary};
  opacity: 0.6;
`;

export default EdgeContextMenu;
